import type { SVGProps } from "react";

export const StatusCircleEmpty = ({
  width = 12,
  height = 12,
  ...props
}: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_619_9104)">
        <circle
          cx="6"
          cy="6"
          r="5.5"
          stroke="currentColor"
          strokeDasharray="2 2"
        />
      </g>
      <defs>
        <clipPath id="clip0_619_9104">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
